import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles, withStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Edit from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import { IntInput } from "components/Input/Index.js";
import useActionTable from "./useActionTable.js";
import { targetedenergyList } from "variables/lists/action";

import { compte } from "variables/patrimoine.js";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 4px solid rgba(231, 231, 231);
  border-top: 4px solid rgba(231, 231, 231);
  background-color: #f5f5f5;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;



const RTContracts = ({ handleSelectedChange }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState, refreshTable } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);
  const [selectedUtilitie, setSelectedUtilitie] = useState({});

  const [open, setOpen] = useState(false);

  const [newData, setNewData] = useState([]);

  const classes = useStyles();

  let energy = "electricity";
  let parameters = "utilities";

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

 
  const ExpandableComponent = ({ data }) => {
    let energy = action.parameters?.impact?.energy;
    let parameters = "utilities";

    return (
      <Container>
        <ExpandableContainer>
          {["heat", "propane", "wood"].includes(energy) && (
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].energyunit} :{" "}
              </ElementTitle>
              <ElementData>{data.details.energyunit}</ElementData>
            </ExpandableElement>
          )}
          {energy !== "electricity" && (
            <ExpandableElement>
              <ElementTitle>
                {compte.energy[energy][parameters].energycost} :{" "}
              </ElementTitle>
              <ElementData>{data.details.energycost}</ElementData>
            </ExpandableElement>
          )}
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].contractnumber} :{" "}
            </ElementTitle>
            <ElementData>{data.details.contractnumber}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].billowner} :{" "}
            </ElementTitle>
            <ElementData>{data.details.billowner}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].contractowner} :{" "}
            </ElementTitle>
            <ElementData>{data.details.contractowner}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].payedby} :{" "}
            </ElementTitle>
            <ElementData>{data.details.payedby}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].contractbegindate} :{" "}
            </ElementTitle>
            <ElementData>{data.details.contractbegindate}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].contractenddate} :{" "}
            </ElementTitle>
            <ElementData>{data.details.contractenddate}</ElementData>
          </ExpandableElement>
  
          {energy == "electricity" && (
            <>
              <ExpandableElement>
                <ElementTitle>
                  {compte.energy[energy][parameters].energycosthph} :{" "}
                </ElementTitle>
                <ElementData>{data.details.energycosthph}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>
                  {compte.energy[energy][parameters].energycosthch} :{" "}
                </ElementTitle>
                <ElementData>{data.details.energycosthch}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>
                  {compte.energy[energy][parameters].energycosthpe} :{" "}
                </ElementTitle>
                <ElementData>{data.details.energycosthpe}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>
                  {compte.energy[energy][parameters].energycosthce} :{" "}
                </ElementTitle>
                <ElementData>{data.details.energycosthce}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>
                  {compte.energy[energy][parameters].energycostpointe} :{" "}
                </ElementTitle>
                <ElementData>{data.details.energycostpointe}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementTitle>
                  {compte.energy[energy][parameters].energycostbase} :{" "}
                </ElementTitle>
                <ElementData>{data.details.energycostbase}</ElementData>
              </ExpandableElement>
            </>
          )}
  
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].othermonthlycost} :{" "}
            </ElementTitle>
            <ElementData>{data.details.othermonthlycost}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].otherunitcost} :{" "}
            </ElementTitle>
            <ElementData>{data.details.otherunitcost}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].associatedfiles} :{" "}
            </ElementTitle>
            <ElementData>{data.details.associatedfiles}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].comments} :{" "}
            </ElementTitle>
            <ElementData>{data.details.comments}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>
              {compte.energy[energy][parameters].description} :{" "}
            </ElementTitle>
            <ElementData>{data.details.description}</ElementData>
          </ExpandableElement>
        </ExpandableContainer>
      </Container>
    );
  };

  //console.log(actionPlans.parameters.general.groups);

  // if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Oups il semble y avoir un problème...{" "}
  //       <button onClick={refetch}>Réesayer</button>
  //     </p>
  //   );
  // }

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.uuid == rowId);

    return indexOfId;
  }
  const columns = [
    {
      name: compte.energy[energy][parameters].contractname,
      selector: (row) => row.details.contractname,
      sortable: true,
    },
    // {
    //   name: "Energie/Fluide",
    //   selector: (row) =>
    //     targetedenergyList.find((energy) => energy.id == row.details.energy)
    //       .name,
    //   sortable: true,
    // },
    {
      name: compte.energy[energy][parameters].name,
      selector: (row) => row.details.name,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].tarifftype,
      selector: (row) => row.details.tarifftype,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].primaryfinalenergyratio,
      selector: (row) => row.details.primaryfinalenergyratio,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].co2ratio,
      selector: (row) => row.details.co2ratio,
      sortable: true,
    },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.uuid == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  // const handleSelectedChange = ({ selectedRows }) => {
  //   selectedRows.map((contract) => (contract.isSelected = true));
  //   setAction((prevState) => ({
  //     ...prevState,
  //     parameters: {
  //       ...prevState.parameters,
  //       impact: {
  //         ...prevState.parameters?.impact,
  //         contracts: selectedRows,
  //       },
  //     },
  //   }));
  // };

  const editEnabled = (row) => async () => {
    editableRowId === row.uuid
      ? setEditableRowId(null)
      : setEditableRowId(row.uuid);
  };

  const editRow = (row) => async () => {
    let obj = newData.find((o) => o.uuid === row.uuid);
    handleClickOpen();

    setSelectedUtilitie(obj);
  };

  const reloadEquipment = (row) => async () => {
    let contracts = [...action.parameters.impact.contracts];

    let updatedContracts = contracts.filter((item) => item.uuid !== row.uuid);

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          contracts: updatedContracts,
        },
      },
    }));

    refreshTable();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const contextMessage = {
    singular: "contrat fournisseur",
    plural: "contrats fournisseurs",
    message: "sélectionné(s)",
  };

  const rowSelectCritera = (row) => row.isSelected == true;
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        //noHeader={true}
        //title="Liste des contrats fournisseurs"
        noDataComponent="Aucun contrats fournisseurs retrouvé dans le patrimoine"
        columns={columns}
        persistTableHead
        subHeader
        expandableRows
        expandableRowsComponent={ExpandableComponent}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        selectableRows
        onSelectedRowsChange={handleSelectedChange}
        selectableRowSelected={rowSelectCritera}
        selectableRowsHighlight
        selectableRowsSingle
        expandOnRowClicked
        pointerOnHover
        {...gridState}
        contextMessage={contextMessage}
      />
    </>
  );
};

export default RTContracts;
